<template>
  <div>
    <app-header title="">
      <template v-if="isAdmin" v-slot:actions>
        <button
          type="button"
          class="btn btn-primary mt-2 mt-xl-0"
          v-c-modal:createModal="{}"
        >
          <i class="far fa-plus"></i> Cluster
        </button>
      </template>
    </app-header>

    <div class="container my-5">
      <h2>Clusters</h2>

      <clusters-list-filters v-model="params" />

      <c-data-list :items="clusters" @load="loadNextPage">
        <template v-slot:columns>
          <div class="col-12 col-lg-8">
            <p>Cluster</p>
          </div>
          <div class="col-6 col-lg-2">
            <p>Applications</p>
          </div>
          <div class="col-6 col-lg-2 text-end">
            <p>Environment</p>
          </div>
        </template>
        <template v-slot:default="slotProps">
          <clusters-list-item :cluster="slotProps.item" />
        </template>
        <template v-slot:empty>
          No clusters to show.
        </template>
      </c-data-list>
    </div>

    <cluster-create-modal v-if="isAdmin" ref="createModal" @created="clusterCreated" />
  </div>
</template>

<script>
import { isEqual, pickBy, isNil } from 'lodash'
import { mapState } from 'vuex'
import { user } from 'mixins'
import ClustersListItem from './ClustersListItem'
import ClustersListFilters from './ClustersListFilters'
import ClusterCreateModal from './ClusterCreateModal'

export default {
  mixins: [user],

  components: {
    ClustersListItem,
    ClustersListFilters,
    ClusterCreateModal
  },

  data () {
    return {
      clusters: [],
      params: {},
      current_page: 1,
      last_page: 1,
      request: null
    }
  },

  mounted () {
    this.fetchPage(1)

    this.$watch('params', (params, oldParams) => {
      if (isEqual(params, oldParams)) {
        return
      }

      this.fetchPage(1)
    })
  },

  computed: {
    ...mapState('user', ['authorized'])
  },

  methods: {
    fetchPage (page) {
      const query = new URLSearchParams({ ...pickBy(this.params, value => !isNil(value)), page }).toString()

      this.request = client({ path: '/clusters?' + query }).then((response) => {
        const data = response.entity

        this.clusters = page === 1 ? data.data : this.clusters.concat(data.data)
        this.current_page = data.current_page
        this.last_page = data.last_page
      })

      return this.request
    },

    async loadNextPage (done) {
      try {
        await this.request

        if (this.current_page >= this.last_page) {
          return done(true)
        }

        await this.fetchPage(this.current_page + 1)

        done()
      } catch (error) {
        done(true)
      }
    },

    clusterCreated () {
      this.fetchPage(1)
    }
  }
}
</script>
